/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Prompt_RequiredInputs */

const en_landing_studio_prompt_required = /** @type {(inputs: Landing_Studio_Prompt_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a prompt first.`)
};

const zh_landing_studio_prompt_required = /** @type {(inputs: Landing_Studio_Prompt_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先填写提示词。`)
};

/**
* | output |
* | --- |
* | "Write a prompt first." |
*
* @param {Landing_Studio_Prompt_RequiredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_prompt_required = /** @type {((inputs?: Landing_Studio_Prompt_RequiredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Prompt_RequiredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_prompt_required(inputs)
	return zh_landing_studio_prompt_required(inputs)
});
export { landing_studio_prompt_required as "landing.studio.prompt_required" }